import { ReactNode, useState, useCallback } from 'react';

import Key from '~interfaces/key';

import SelectedKeysContext from './selectedKeysContext';

interface KeyProviderProps {
	children: ReactNode;
}

export const SelectedKeysProvider = ({ children }: KeyProviderProps) => {
	const [selectedKeys, setSelectedKeys] = useState<Key[]>([]);
	const [singleKey, setSingleKey] = useState<Key | undefined>(undefined);

	const addKey = useCallback((key: Key) => {
		setSelectedKeys((prev) =>
			prev.find((selectedKey) => selectedKey.id == key.id) ? prev : [...prev, key]
		);
	}, []);

	const removeKey = useCallback((key: Key) => {
		setSelectedKeys((prev) => prev.filter((selectedKey) => selectedKey.id !== key.id));
	}, []);

	const replaceSelectedKeys = useCallback((keys: Key[]) => {
		setSelectedKeys(keys);
	}, []);

	const updateSingleKey = useCallback((key: Key | undefined) => {
		setSingleKey(key);
	}, []);

	return (
		<SelectedKeysContext
			value={{ selectedKeys, singleKey, addKey, removeKey, replaceSelectedKeys, updateSingleKey }}
		>
			{children}
		</SelectedKeysContext>
	);
};

export default SelectedKeysProvider;
